<template>
  <div class="step-progress">
    <div v-for="step in steps" :key="step.number" class="step-container">
      <div class="step">step {{step.number}}: {{step.title}}</div>
      <div class="step-status-wrapper flex items-center content-between w-max">
        <div class="status-wrapper">
          <div :class="['current-step', { show: step.number === currentStep && !step.isComplete }]">
            <svg class="leaf-icon" viewBox="0 0 425 425">
              <use xlink:href="#leaf-icon"></use>
            </svg>
          </div>
          <div v-if="step.isComplete" :class="['complete', { show: step.isComplete }]">
            <div>complete</div>
            <div :class="['link', `edit-step-${step.number}`]" @click="sendStep(step.number)">edit</div>
          </div>
        </div>
        <div v-if="showDetails(step)">
          <fai :icon="['fa', 'memo-pad']"
            class="memopad blue-icon cursor-pointer left-4 ml-3"
            @click="showRequestModalAndGetData"
          />
          <ad-sponsor-request-modal v-if="showRequestModal"
            :selectedRequest="selectedRequest"
            @closeModal="showRequestModal = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
  import AdSponsorRequestModal from '../Ads/AdSponsorRequestModal.vue'

  export default {
    props: {
      currentStep: Number,
      steps: Array,
      ad: Object
    },

    name: 'StepProgress',

    components: {
      AdSponsorRequestModal
    },

    data() {
      return {
        showRequestModal: false
      }
    },

    computed: {
      selectedRequest() {
        if (!this.ad.marketplace_sponsor_request_id) return null
        return this.merchantRequests.requests.find(({id}) => id === this.ad.marketplace_sponsor_request_id)
      },
      ...mapState(['merchantRequests'])
    },

    methods: {
      sendStep(step) {
        this.$emit('validateStep', step)
      },
      showDetails(currentStep) {
        return !!this.ad.marketplace_sponsor_request_id && currentStep.number === 1 && !!this.selectedRequest
      },
      showRequestModalAndGetData() {
        if (!this.selectedRequest?.request_log) return
        this.showRequestModal = true
      }
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.step-progress
  background: $primary-transparent
  display: flex

.step-container
  border-right: 1px solid $primary-color
  flex-basis: 25%
  font-size: 1.25rem
  padding: 1rem
  text-align: center
  @media only screen and (max-width: 40em)
    font-size: .8rem
  &:last-child
    border-right: none

.step
  color: $negative-color
  margin-bottom: 1rem

.complete, .current-step
  color: $title-color
  display: none
  flex-direction: column
  font-weight: bold
  justify-content: center
  &.show
    display: inline-flex
    opacity: 1

svg.leaf-icon
  fill: $primary-color
  height: 50px
  width: 50px
  @media only screen and (max-width: 40em)
    height: 30px
    width: 30px

.link
  cursor: pointer
  margin-top: 1rem
  @media only screen and (max-width: 40em)
    margin-top: .5rem

.step-progress
  .blue-icon
    color: #128ff9
    font-size: 1.75rem
  .step-status-wrapper
    margin: 0 auto
</style>